import React, { useContext, useEffect, useState } from "react";
import "../Styles/Checkout.css";
import { CartState } from "../Context/Context";
import swal from "sweetalert";
import ProductContext from "../Context/productContext";
import { useNavigate } from "react-router-dom";

async function loadScript(src) {

  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export default function Checkout() {
  const [discountPrice,setDiscountPrice]=useState();
  const [promoCode, setPromoCode] = useState('');
  const [lastTotal, setLastTotal] = useState()
  const [finalDiscount,setFinalDiscount]=useState();
  const context = useContext(ProductContext);
  const { uploadOrders, handleStock, fetchPromoPercent ,percent} = context;
const [percentValue,setPercentValue]=useState(0)
  const initialValues = {
    firstName: "",
    lastName: "",
    phoneNo: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  };

  const [formValues, setformValues] = useState(initialValues);
  const [formError, setformError] = useState({});
  const [isSubmit, setisSubmit] = useState(false);
  var {
    state: { cart },
  } = CartState();
  const navigate = useNavigate();
  const [total, setTotal] = useState();
  const [finalTotal, setFinalTotal] = useState();
  
  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      displayRazorPay();
    }
  
  
  }, [formError]);

  useEffect(() => {
    setTotal(cart.reduce((acc, curr) => acc + curr.specialprice * curr.qty, 0));
  }, [cart]);

  useEffect(() => {
    total < 500 ? setFinalTotal(total + 100) : setFinalTotal(total);
  }, [total]);
   useEffect(() => {
    setLastTotal(!finalDiscount?  finalTotal:finalDiscount<500? finalDiscount +100 : finalDiscount)
  }, [finalDiscount,finalTotal]);
  

  useEffect(()=>{
    fetchPromoPercent(promoCode)
    
  }, [promoCode])   
  
  

  const details = cart.map((item) => ({
    id: item.id,
    size: item.size,
    stock: item.stock,
    title: item.title,
    Qty: item.qty,
    color: item.color,
  }));

  async function displayRazorPay() {
    const baseURL="https://dokmen-api.vercel.app/razorpay"
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("failed");
      return;
    }
    const data = await fetch(baseURL, {
      method: "POST",
      // mode: "cross-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ post: lastTotal }),
    }).then((value) => value.json());
    const options = {
      key: "rzp_test_VsCdgSHQjnyYP9",
      currency: data.currency,
      amount: data.amount,
      order_id: data.id,
      name: "Dokmen",
      description: "Thanks for shopping",
      image: "Images/Logo.png",

      handler: function (response) {
        const razorpayId = response.razorpay_payment_id;
        const razoroderId = response.razorpay_order_id;

        swal({
          title: "Payment SuccessFull",
          text: `Your Order_Id is "${response.razorpay_order_id}"
          Your Payment_Id is "${response.razorpay_payment_id}" `,
          icon: "success",
        });

        if (razorpayId !== undefined) {
          uploadOrders(
            formValues.firstName + formValues.lastName,
            formValues.phoneNo,
            formValues.address,
            formValues.city,
            formValues.state,
            razorpayId,
            razoroderId,
            details,
            total
          );

          details.map((item) => {
            handleStock(item.id, item.Qty, item.stock);
          });
          navigate("/");
         while(cart.length>0){
           cart.pop()
         }
        }
      },
      prefill: {
        name: formValues.firstName,
        contact: formValues.phoneNo,
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.on("payment.failed", function (response) {
      swal({
        title: "Payment Failed",
        text: `${response.error.code}
               Please Try Again `,
        icon: "error",
      });
    });

    paymentObject.open();
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setformError(validate(formValues));
    setisSubmit(true);
  };


  const validate = (values) => {
    const errors = {};
    if (!values.phoneNo) {
      errors.phoneNo = "Phone No. is Required";
    }

    if (!values.firstName) {
      errors.firstName = "First Name is Required";
    }
    if (!values.lastName) {
      errors.lastName = "Last Name is Required";
    }
    if (!values.address) {
      errors.address = "Address is Required";
    }
    if (!values.city) {
      errors.city = "City is Required";
    }
    if (!values.state) {
      errors.state = "State is Required";
    }
    if (!values.pincode) {
      errors.pincode = "Pin Code is Required";
    }

    return errors;
  };

 
  
  
  const calcDiscount=(percentValue,total)=>{
    if(percentValue&&total){

    setDiscountPrice (percentValue/100*total);
      setFinalDiscount(total-discountPrice);
    }
    else{
      setFinalDiscount();
    }
  }
  
  useEffect(() => {
    calcDiscount(percentValue,total)
    // finalDiscount<500? setFinalDiscount(finalDiscount+100):setFinalDiscount(finalDiscount);
  }, [percentValue , finalDiscount])
  

  
  return (
    <>
      <section>
        <div className="shipping-details">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <p className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  Order Summary : <b>₹ {finalTotal}</b>
                </button>
              </p>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  {cart.map((item) => (
                    <>
                      <div className="product-details" key={item.id}>
                        <div>
                          <span style={{ position: "relative" }}>
                            <img
                              src={item.image}
                              alt=""
                              height="80px"
                              width="80px"
                            />
                            <span
                              className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                              style={{ backgroundColor: "black" }}
                            >
                              {item.qty}
                            </span>
                          </span>
                          {item.title}
                        </div>

                        <div className="item-price">
                          ₹ {item.specialprice * item.qty}
                        </div>
                      </div>
                    </>
                  ))}

                  <div className="price-details">
                    <div className="price-title">
                      <p>SubTotal</p>
                      <p>Shipping</p>
                      <br />
                      <br />
                      <p>Total</p>
                    </div>
                    <div className="price">
                      <p>₹ {total}</p>
                      <p> {total < 500 ? "₹ 100" : "Free"}</p>
                      <br />
                      <br />
                      <p>{finalTotal}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-body">
            <form onSubmit={handleSubmit}>
              <h4>Shipping Details</h4>

              <div className="textfield-container">
                <div className="t-1">
                  <input
                    type="number"
                    placeholder="Phone No."
                    className="textfield"
                    value={formValues.phoneNo}
                    onChange={handleChange}
                    name="phoneNo"
                  />

                  <p>{formError.phoneNo}</p>
                </div>

                <div className="t-2">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    className="textfield"
                    value={formValues.firstName}
                    onChange={handleChange}
                  />
                  <p>{formError.firstName}</p>
                </div>

                <div className="t-3">
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    className="textfield"
                    value={formValues.lastName}
                    onChange={handleChange}
                  />
                  <p>{formError.lastName}</p>
                </div>

                <div className="t-4">
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    className="textfield"
                    value={formValues.address}
                    onChange={handleChange}
                  />
                  <p>{formError.address}</p>
                </div>

                <div className="t-5">
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    className="textfield"
                    value={formValues.city}
                    onChange={handleChange}
                  />
                  <p>{formError.city}</p>
                </div>

                <div className="t-6">
                  <input
                    type="text"
                    name="state"
                    placeholder="State"
                    className="textfield"
                    value={formValues.state}
                    onChange={handleChange}
                  />
                  <p>{formError.state}</p>
                </div>

                <div className="t-7">
                  <input
                    name="pincode"
                    type="number"
                    placeholder="Pin Code"
                    className="textfield"
                    value={formValues.pincode}
                    onChange={handleChange}
                  />
                  <p>{formError.pincode}</p>
                </div>
              </div>
              <div className="container-fluid p-0 pt-3">
              <h6 className="m-0">Have a PromoCode ?</h6>
            <div className="row mt-4">
              <div className="col-6 col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="autoSizingInput"
                  placeholder="Promo Code"
                  onChange={(e) => setPromoCode(e.target.value)}

                  value={promoCode}

                />
                
              </div>
              <div className="col-6 col-sm-4 d-flex justify-content-center">
                <button
                type="button"
                  className="btn"
                  style={{ backgroundColor: "#032044", color: "white" }}
                  onClick={()=>{
                    
                    setPercentValue(percent)
                    
                  }}
                >
                  Apply
                </button>
              </div>
              {percentValue===undefined &&  <p style={{color:"red",fontSize:"12px"}} >Promo Code Doesn't Exists</p>}
                {percentValue>0 && <p style={{color:"darkGreen",fontSize:"12px",fontWeight:"bold"}} >Promo Code Applied</p>}
            </div>
          </div>

              <span className="submit-btn">
                <button type="submit" onClick={handleSubmit}>Make Payment</button>
              </span>
            </form>


            
          </div>
          
        </div>

        <div className="billing-price-details">
          {cart.map((item) => (
            <>
              <div className="product-details">
                <div>
                  <span style={{ position: "relative" }}>
                    <img src={item.image} alt="" height="80px" width="80px" />
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                      style={{ backgroundColor: "black" }}
                    >
                      {item.qty}
                    </span>
                  </span>

                  {item.title}
                </div>

                <div className="item-price">
                  ₹ {item.specialprice * item.qty}
                </div>
              </div>
            </>
          ))}

          

          <div className="price-details">
            <div className="price-title">
              <p>SubTotal</p>
              {percentValue ?<p>Additional Discount</p>:"" }
              <p>Shipping</p>
              <br />
              <br />
              <p>Total</p>
            </div>
            <div className="price">
              <p>₹ {total}</p>
              {percentValue ? <p>- ₹ {parseFloat(discountPrice).toFixed(2)}</p>:"" }
              <p> {total < 500 ? "₹ 100" : "Free"}</p>

              <br />
              <br />
              <p>{lastTotal}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
